"use client";

import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { Checkbox } from "@ui/checkbox";
import { Input } from "@ui/input";
import { InputGroup } from "@ui/input-group";
import { Message } from "@ui/message";
import { RadioGroup } from "@ui/radio";
import { Select } from "@ui/select";
import { Textarea } from "@ui/textarea";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  fieldComponents: {
    Checkbox,
    Input,
    InputGroup,
    RadioGroup,
    Select,
    Textarea,
  },
  formComponents: {
    FormError: Message,
  },
  fieldContext,
  formContext,
});
